import React from 'react'

//lazy load learners dashboard pages here.
const Dashboard = React.lazy(() => import('../pages/leaners/Dashboard'))
const Software = React.lazy(() => import('../pages/leaners/Software'))
const MyCourses = React.lazy(() => import('../pages/leaners/MyCourses'))
const Certificates = React.lazy(() => import('../pages/leaners/Certificates'))
const CourseLib = React.lazy(() => import('../pages/leaners/CourseLib'))
const Resources = React.lazy(() => import('../pages/leaners/Resources'))

const LearnersDashboardRoutes = [
  { path: '/learner', exact: true, name: 'Home' },
  { path: 'dashboard', name: 'Dashboard', element: Dashboard },
  { path: 'software', name: 'Software', element: Software },
  { path: 'my-courses', name: 'MyCourses', element: MyCourses },
  { path: 'certificates', name: 'Certificates', element: Certificates },
  { path: 'resources', name: 'Resources', element: Resources },
  { path: 'course-library', name: 'CourseLib', element: CourseLib },
]

export default LearnersDashboardRoutes
